module.exports = __webpack_public_path__ + "b21c6fe31d834bceae3ec47758f8f5cb.png";